<template>
  <div class="w-full flex flex-col pb-[12.5px]">
    <!-- Handle -->
    <div
      class="w-[60px] min-h-1 max-h-1 bg-gray-800/20 rounded-xs self-center mt-2.5 mb-1.5"
    />

    <!-- Folder details -->
    <div
      class="w-full px-[14px] pt-[5.5px] pb-[3.5px] font-secondary text-gray-800"
    >
      <div class="flex items-center">
        <ThumbnailIcon
          :icon-size="36"
          type="folder"
          class="min-w-9 max-w-9 h-9 mr-2.5"
        />
        <div v-truncate class="w-full">
          <div
            class="font-medium text-[16px] leading-[18px] mb-[1px]"
            data-truncate-target
          >
            {{ folder.name }}
          </div>
          <div class="text-[13px] opacity-50">
            {{ folder.totalFiles }} {{ pluralize('file', folder.totalFiles) }}
          </div>
        </div>
      </div>
    </div>

    <div class="w-full my-[12.5px] min-h-[1px] max-h-[1px] bg-gray-800/10" />

    <TallListItem
      icon="Delete"
      @click="handleAction(Dialogs.DeleteFolders, { items: [folder] })"
    >
      Delete
    </TallListItem>

    <TallListItem
      icon="Rename"
      @click="handleAction(Dialogs.RenameFolder, { item: folder })"
    >
      Rename
    </TallListItem>

    <TallListItem
      icon="Move"
      @click="handleAction(Dialogs.MoveItems, { ids: [folder.id] })"
    >
      Move
    </TallListItem>

    <div class="w-full my-[12.5px] min-h-[1px] max-h-[1px] bg-gray-800/10" />

    <TallListItem icon="Info" @click="handleFolderInfoClick">
      Folder info
    </TallListItem>
  </div>
</template>

<script setup lang="ts">
import { ThumbnailIcon } from '@dacr/ui'
import { TallListItem } from '@/shared/components/Menu'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import type { Folder } from '@/shared/graphql/router/graphql'
import pluralize from 'pluralize'

const { open } = useDialog()

const props = defineProps<{
  folder: Folder
}>()

const folder = props.folder

const handleAction = (
  dialog: Dialogs,
  extraProps?: Record<string, unknown>
) => {
  open(dialog, { props: extraProps })
}

const handleFolderInfoClick = () => {
  open(Dialogs.FolderInfo, {
    props: { folder: props.folder },
  })
}
</script>
